/* eslint-disable no-undef, class-methods-use-this, prefer-destructuring, no-param-reassign */

class SliderGallery {
  constructor() {
    const gallery = document.getElementsByClassName("slider-gallery")[0];
    if (gallery) {
      this.init();
    }
  }

  init() {
    import(/* webpackChunkName: "fslightbox" */ "fslightbox").then(() => {
      refreshFsLightbox();
    });
  }
}

export default SliderGallery;
